var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionScene } from "./actionScenes";
var initial = {
    currentScene: undefined,
};
export var createReducerScenes = function (scenesConfig) { return function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionScene.Swap:
            return __assign({}, state, { currentScene: scenesConfig[action.sceneId] });
        default:
            return state;
    }
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/createReducerScenes.ts
// module id = 2975
// module chunks = 3